<template>
  <div id="app">
    <div class="container-fluid">
      <vue-page-transition name="fade-in-down">
        <router-view />
      </vue-page-transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  meta: [
    {
      name: "keywords",
      content:
        "taski, usetaski, decisions, productivity, decision tools, todos, productivity tool"
    },
    {
      name: "description",
      content:
        "Taski is the journey to Productivity. From day to day tasks, to important life decisions, it covers it all. Access different techniques to focus more and increase overall productivity."
    },
    {
      name: "subject",
      content:
        "Taski is the journey to Productivity. From day to day tasks, to important life decisions, it covers it all. Access different techniques to focus more and increase overall productivity."
    },
    { name: "author", content: "@mkfeuhrer" },
    { name: "url", content: "https://usetaski.com" },
    { name: "og:title", content: "Taski" },
    { name: "og:site_name", content: "Taski" },
    { name: "og:type", content: "website" },
    { name: "og:url", content: "https://usetaski.com" },
    {
      name: "og:description",
      content:
        "Taski is the journey to Productivity. From day to day tasks, to important life decisions, it covers it all. Access different techniques to focus more and increase overall productivity."
    }
  ]
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
